<script>
    // based on suggestions from:
    // Inclusive Components by Heydon Pickering https://inclusive-components.design/collapsible-sections/
    export let headerText = 'Read More';
    export let headerTextExpanded = 'Read Less';

    let expanded = false
</script>

<div class="collapsible">
    <p>
        <a on:click={() => expanded = !expanded} class="btn {expanded ? "mdi mdi-arrow-up" : "mdi mdi-arrow-down"}">{expanded ? headerTextExpanded : headerText}</a>
    </p>
    
    <div class='contents' hidden={!expanded}>
        <slot></slot>
    </div>
</div>

<style>
	p {
		margin: 10;
	}
</style>